import { NavLink } from 'react-router-dom';

const links = [
  { to: '/', label: 'Dashboard' },
  { to: '/content', label: 'Inhalte' },
  { to: '/navigation', label: 'Menü & Navigation' },
  { to: '/themes', label: 'Designs & Themes' },
  { to: '/components', label: 'Komponenten' },
  { to: '/policies', label: 'Content Policies' },
  { to: '/explorer', label: 'Content Explorer' },
  { to: '/media', label: 'Medien' },
  { to: '/settings', label: 'Einstellungen' },
  { to: '/publish', label: 'Veröffentlichen' },
  { to: '/users', label: 'Benutzer', role: 'cms-admin' },
];

export default function Sidebar({ user }) {
  return (
    <aside className="sidebar">
      <div>
        <div className="brand">Bcknd CMS</div>
        <div className="muted">{user?.email}</div>
      </div>
      <nav className="sidebar-nav">
        {links
          .filter((link) => !link.role || user?.groups?.includes(link.role))
          .map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              end={link.to === '/'}
              className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
            >
              {link.label}
            </NavLink>
          ))}
      </nav>
    </aside>
  );
}
